// extracted by mini-css-extract-plugin
module.exports = {"sub":"ArticlePage_sub_1g0iw","spinAround":"ArticlePage_spinAround_2KW_R"};